// extracted by mini-css-extract-plugin
export default {"p_content":"_923583f09b"};